module.exports = __webpack_public_path__ + "static/media/reflective-listening@2x.f8569527.png";